module.exports = __webpack_public_path__ + "img/apple-icon-120x120.e0f63258.png";